"use client";

import { metadata, type AITool } from "@app/_metadata";
import { CoreMetricsSheet } from "@shared-components/core-metrics-sheet";
import { ActiveFeatureFlags } from "@shared-components/global/active-feature-flags";
import { Ident } from "@shared-components/global/ident";
import { TopBarMenu } from "@shared-components/global/top-bar-menu";
import { UserDropdown } from "@shared-components/global/user-dropdown";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { LanguageDropdown } from "@shared-components/language-dropdown";
import { DegradedFeatureFlagFallback } from "@shared-components/degraded-feature-flag-fallback";

interface TopBarProps {
  leftChildren?: React.ReactNode;
  rightChildren?: React.ReactNode;
  aiTools: AITool[];
  hideBottomBorder?: boolean;
}

/**
 * Topbar
 *
 * @param props TopBarProps
 */
export const TopBar = (props: TopBarProps) => {
  const path = usePathname();
  // Find active tool
  const activeAiTool = metadata.aiTools?.find((appMeta) =>
    path.includes(appMeta.slug),
  );

  /**
   * Render
   */
  return (
    <>
      <div
        className={`fixed left-0 top-0 z-50 flex h-14 w-full flex-row items-center justify-between bg-background px-2 sm:px-4 ${props.hideBottomBorder ? "" : "border-b border-border"}`}
      >
        <div className="flex min-w-0 flex-1 flex-row items-center">
          <Link href={"/"} className="shrink-0 sm:w-[233px]">
            <Ident aiTool={activeAiTool} hideTextOnMobile />
          </Link>
          <DegradedFeatureFlagFallback>
            <span className="hidden md:block">{props.leftChildren}</span>
          </DegradedFeatureFlagFallback>
        </div>
        <div className="flex shrink-0 flex-row items-center gap-1 sm:gap-2">
          <ActiveFeatureFlags />
          <CoreMetricsSheet />
          <LanguageDropdown />
          {props.rightChildren}
          <TopBarMenu activeAiTool={activeAiTool!} />
          <UserDropdown />
        </div>
      </div>
    </>
  );
};
